import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from './form-response.graphql';
import * as fromActions from './form-response.actions';
import {map, switchMap} from 'rxjs';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {closeRequest} from "./form-response.actions";
import {CLOSE_SERVICE_REQUEST_MUTATION} from "./form-response.graphql";
import {PaginationService} from "../../../../services/pagination.service";


@Injectable()
export class FormResponseEffects {

  citizenGetFormResponses$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetFormResponses),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_FORM_RESPONSES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            serviceUniqueId: action?.serviceUniqueId,
            pageNumber: action?.pageNumber,
            itemsPerPage: action?.itemsPerPage,
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable form fields'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            if(result?.response?.status ) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.itemsPerPage});
              this.store.dispatch(fromActions.loadFormResponses({formResponses: result?.data}))
            } else return []
          }
        })
      );
    })
  ), { dispatch: false });

  getFormResponses$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getFormResponses),
    switchMap((action) => {
      return this.apollo.query({
        query: action?.fewFields ? fromGraphql.GET_FORM_RESPONSES_FEW_FIELDS: fromGraphql.GET_FORM_RESPONSES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            requestType: action?.requestType,
            pageNumber: action?.pageNumber,
            itemsPerPage: action?.itemsPerPage,
            serviceUniqueId: action?.serviceUniqueId,
            responseUniqueId: action?.responseUniqueId
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable form fields'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            if(result?.response?.status ) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.itemsPerPage});
              this.store.dispatch(fromActions.loadFormResponses({formResponses: result?.data}))
            } else return []
          }
        })
      );
    })
  ), { dispatch: false });

  closeRequest$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.closeRequest),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CLOSE_SERVICE_REQUEST_MUTATION,
        variables: {
          input:{
            requestUniqueId: action?.requestUniqueId,
            attachments: action?.attachments,
            comment: action?.comment
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.upsertFormResponse({ formResponse: result?.data }));
              await this.notificationService.successMessage('Closed Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService,
    private paginationService: PaginationService,

  ) {}
}
